import {mapActions} from 'vuex'
import { isEmpty } from 'lodash-es'
//
import AddMontage from '@/components/product-presentation/product-add-montage/product-add-montage'
import PriceCTA from '@/components/product-presentation/product-price-cta/product-price-cta'
import ProductFilters from '@/components/product-presentation/product-filters/product-filters'
import ProductSlider from '@/components/product-presentation/product-slider/product-slider'
import ArToggle from '@/components/ar/ar-toggle/ar-toggle.vue'
//
import lang from '@data/lang.json'

const ProductPresentation = {
  // Components
  components: {
    'add-montage': AddMontage,
    'ar-toggle': ArToggle,
    'price-cta': PriceCTA,
    'product-filters': ProductFilters,
    'product-slider': ProductSlider,
  },
  // Props
  props: [
    'endpoint',
    'installationPrice',
    'parentContentId',
    'productPrice',
    'productId',
    'variations',
  ],
  // Data
  data() {
    return {
      addInstallation: false,
      dimensions: {},
      safetyClassifications: [],
      lang: lang.ProductPresentation,
      price: {
        installationPrice: null,
        price: 0,
        printPrice: 0,
      },
      quantity: 1,
      showInstallation: false,
      variationId: null,
      windowSmall: window.innerWidth < 990,
    }
  },
  // Methods
  methods: {
    ...mapActions('cart', ['addProductToCart']),
    setIdAndPrice: function(id, installationPrice, price) {
      // Set variation id
      this.variationId = id ? id : null

      // Set installation price
      if (installationPrice) {
        this.showInstallation = true
        this.price.installationPrice = installationPrice
      }

      // Set price
      if (price) {
        this.price.price = price
      } else {
        this.price.price = 0
      }
    },
    setSelected: function() {
      if (!isEmpty(this.dimensions)) return null

      let selectedItem = {}
      if (this.variations.length < 1) {
        selectedItem = {
          id: this.productId ? this.productId : null,
          installationPrice: this.installationPrice
            ? this.installationPrice
            : null,
          price: this.productPrice ? this.productPrice : null,
        }
      } else {
        selectedItem = this.variations.find(item => item.Selected)
          ? this.variations.find(item => item.Selected)
          : this.variations[0]
      }

      this.setIdAndPrice(
        selectedItem.Id,
        selectedItem.InstallationPrice,
        selectedItem.Price
      )

      // Set print price
      this.price.printPrice = this.addInstallation
        ? this.price.installationPrice
        : this.price.price
    },
    checkDimensionMatch: function() {
      // Reset
      this.price.price = 0
      this.price.installationPrice = null
      this.addInstallation = false
      this.showInstallation = false

      for (let index = 0; index < this.variations.length; index++) {
        const item = this.variations[index]

        if (
          this.dimensions.height == item.Height &&
          this.dimensions.width == item.Width
        )
          this.setIdAndPrice(item.Id, item.InstallationPrice, item.Price)
      }

      // Set print price
      this.price.printPrice = this.addInstallation
        ? this.price.installationPrice
        : this.price.price
    },
    addInstallationChange: function(value) {
      this.addInstallation = value
      this.price.printPrice = this.addInstallation
        ? this.price.installationPrice
        : this.price.price
    },
    readMoreClick: function() {
      bus.$emit('info_tabs_scroll')
    },
    toggleFormModal: function() {
      const formParams = {
        Height: parseInt(this.dimensions.height),
        Id: this.productId,
        Width: parseInt(this.dimensions.width),
      }
      bus.$emit('form_modal_toggle', 'estimationForm', formParams)
    },
    updateCart: function() {
      const fetchParams = {
        AddInstallation: this.addInstallation,
        Id: this.productId,
        ParentContentId: this.parentContentId,
        VariationId: this.variationId,
        Quantity: this.quantity,
      }
      this.$store.dispatch('cart/setCart', {
        api: this.endpoint,
        params: fetchParams,
      })
    },
  },
  // Life cycle
  created() {
    bus.$on('toggle_estimation_form', () => {
      this.toggleFormModal()
    })
    bus.$on('updateMontage', value => {
      this.addInstallationChange(value)
    })
    bus.$on('updateQuantity', value => {
      this.quantity = value
    })
    bus.$on('updateProductDimensions', dimensions => {
      this.dimensions.height = dimensions.height
      this.dimensions.width = dimensions.width
      this.checkDimensionMatch()
    })
    bus.$on('updateSafetyClassifications', items => {
      this.safetyClassifications = items
    })
    bus.$on('updateCart', () => {
      this.updateCart()
    })
    bus.$on('window_resize', windowSize => {
      this.windowSmall = windowSize.width < 990
    })
  },
  mounted() {
    this.setSelected()

    if (this.productPrice) {
      this.price.printPrice = this.productPrice
    }
  },
}

export default ProductPresentation
